import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import LinkButton, { LinkButtonProps } from '@/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';

import { HTMLDataTrackerProps } from '@/app/types';
import { BlockComponentModel } from '@/cms/types/blok-component';

import { transformFromCMSLink } from '../LinkButton/utils';
import { pullDataTrackers } from '../../molecules/imageLink/utils';

export type ImageTextLinkStrapiBlock = {
  image?: ImageStrapiProps;
  text?: LinkButtonStrapiProps;
  link: LinkButtonStrapiProps;
};

const defaultLinkButtonWrapperProps: Partial<LinkButtonProps> = {
  variant: 'text',
  underline: false,
  classNames: { root: 'px-0 h-6' },
};

export type ImageLinkStrapiProps = BlockComponentModel<
  ImageTextLinkStrapiBlock,
  /* FIXME: this needs to be typed properly in the future, as of now it uses one
      type for spreading `inner` in all 3 sub-components

      Keeping as is for backwards compatibility
    */
  HTMLDataTrackerProps & Record<string, unknown>
>;

export function ImageLinkStrapi(props: ImageLinkStrapiProps) {
  const { block, inner, ...rest } = props;
  const { image, link } = block;

  return (
    <LinkButton
      {...transformFromCMSLink(link)}
      {...pullDataTrackers(inner || {})}
      {...defaultLinkButtonWrapperProps}
    >
      <span className='flex gap-2 items-center'>
        {image && <ImageStrapi block={image} inner={inner} {...rest} />}
        {link.text && (
          <span className={(inner?.classNames as Record<string, string>)?.root}>
            {link.text}
          </span>
        )}
      </span>
    </LinkButton>
  );
}
